<template>
	<div class="speed-tabs">
		<NoBindAlert v-if="isNoBind"></NoBindAlert>
		<div class="tabs-wrap" v-else>
			<div class="tab-item tab-item1" @click="go1Click">
				<div class="tab-item-icon"></div>
				<div>望远镜加速</div>
			</div>
			<div class="tab-item tab-item2" @click="go2Click">
				<div class="tab-item-icon"></div>
				<div>预缓存加速</div>
			</div>
			<div class="tab-item tab-item3" @click="go3Click">
				<div class="tab-item-icon"></div>
				<div>小宝驿站</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions } from "vuex";
import NoBindAlert from "@/components/NoBindAlert.vue";
export default {
	name: "SpeedTabs",
	components: {
		NoBindAlert,
	},
	data: function () {
		return {
			isNoBind: false,
			currentTab: 0,
			peerid: "",
		};
	},
	methods: {
		...mapActions(["bindget"]),
		go1Click: function () {
			let _that = this;
			_that.$router.push({ path: "/home/speedtelescope" });
		},
		go2Click: function () {
			let _that = this;
			_that.$router.push({ path: "/home/speed" });
		},
		go3Click: function () {
			let _that = this;
			_that.$router.push({ path: "/home/speedshare" });
		},
	},
	computed: {},
	mounted() {
		let _that = this;
		_that.bindget([
			function (err, data) {
				if (data && !data.rtn) {
					//rtn等于0时，后台不返回此字段
					if (data && data.terms && data.terms.length > 0) {
						_that.isNoBind = false;
					} else {
						_that.isNoBind = true;
					}
				} else {
					_that.isNoBind = true;
				}
			},
		]);
	},
};
</script>
<style lang="less" scoped>
.speed-tabs {
	height: 100%;
	// position: relative;

	.tabs-wrap {
		position: relative;
		height: 516px;
		background-image: url("../assets/speedTabs/speed_tabs.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center;
		box-shadow: 0px 0px 5px 0px rgba(193, 193, 193, 0.5);
		margin: 10px;

		.tab-item {
			cursor: pointer;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 167px;
			height: 173px;
			background-color: rgba(50, 75, 131, 0.08);
			border-radius: 7px;
			border: 1px solid #cbd0de;
			box-sizing: border-box;
			color: #7e89a3;
			font-size: 16px;
			font-weight: bold;

			.tab-item-icon {
				margin-top: 3px;
				margin-bottom: 14px;
				width: 73px;
				height: 73px;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				background-position: center;
			}
		}
		.tab-item1 {
			position: absolute;
			top: 167px;
			left: 170px;
			.tab-item-icon {
				background-image: url("../assets/speedTabs/tab1_normal.svg");
			}
		}
		.tab-item2 {
			position: absolute;
			top: 167px;
			left: 364px;
			.tab-item-icon {
				background-image: url("../assets/speedTabs/tab2_normal.svg");
			}
		}
		.tab-item3 {
			position: absolute;
			top: 167px;
			left: 558px;
			.tab-item-icon {
				background-image: url("../assets/speedTabs/tab3_normal.svg");
			}
		}

		.tab-item:hover {
			font-weight: bold;
			color: #f5f5f5;
			width: 179px;
			height: 185px;
			background-color: #324b83;
			background-image: linear-gradient(to right, #324b83, #1e3469);
			box-shadow: 0px 0px 15px 0px rgba(193, 193, 193, 1);
		}

		.tab-item1:hover {
			left: 164px;
			top: 161px;
			.tab-item-icon {
				background-image: url("../assets/speedTabs/tab1_hover.svg");
			}
		}
		.tab-item2:hover {
			top: 161px;
			left: 358px;
			.tab-item-icon {
				background-image: url("../assets/speedTabs/tab2_hover.svg");
			}
		}
		.tab-item3:hover {
			left: 552px;
			top: 161px;
			.tab-item-icon {
				background-image: url("../assets/speedTabs/tab3_hover.svg");
			}
		}
	}
	.tab-item-wrap2,
	.tab-item-wrap3 {
		margin-left: 27px;
	}
}
</style>
